import styled from "styled-components";

export const ContentDescription = styled.div`
    border: 1px solid ${({ theme }) => theme.color.light};
    margin: 0 0 20px 0;
`;

export const ProductsGrid = styled.div`
margin-top: 0.625rem;

`;

export const WrappLoadMore = styled.div`
    text-align: center;
    margin-top: 15px;
    padding-bottom: 15px;
`;

export const WrapperContainer = styled.div`
    background-color: ${({ theme }) => theme.color.iceLight};
    padding-top: 20px;
`;